import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiClient } from '@/lib/api-client';

export interface Operator {
  id: string;
  email: string;
  name: string;
  createdAt: string;
  disabledAt: string | null;
}

export function useOperators() {
  return useQuery({
    queryKey: ['operators'],
    queryFn: async () => (await apiClient.get<Operator[]>('/admin/operators')).data,
    retry: false,
  });
}

export function useCreateOperator() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { email: string; name: string; password: string }) =>
      (await apiClient.post('/admin/operators', input)).data,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['operators'] });
      toast.success('Operador creado');
    },
    onError: (e: unknown) =>
      toast.error(
        (e as { response?: { data?: { message?: string } } }).response?.data?.message ??
          'No se pudo crear el operador',
      ),
  });
}

export function useResetOperatorPassword() {
  return useMutation({
    mutationFn: async ({ id, password }: { id: string; password: string }) =>
      apiClient.put(`/admin/operators/${id}/password`, { password }),
    onSuccess: () => toast.success('Contraseña actualizada'),
    onError: (e: unknown) =>
      toast.error(
        (e as { response?: { data?: { message?: string } } }).response?.data?.message ??
          'No se pudo cambiar la contraseña',
      ),
  });
}
